import React from 'react';
import { Text as BaseText } from '@tcaster/tcaster-web-lib';
import { FONT_SIZE } from '@tcaster/tcaster-theme';

const Text = props => (
  <BaseText color="greyscale.grey1" fontSize={FONT_SIZE.normal} lineHeight={1.38} {...props} />
);

const Title = props => <Text fontSize={[FONT_SIZE.large]} fontWeight="bold" {...props} />; // bold = 500
const Subtitle = props => <Text fontSize={[FONT_SIZE.semilarge]} {...props} />;
const TextData = props => (
  <Text fontFamily="data" fontWeight="bold" fontSize="20px" lineHeight="1.2em" {...props} />
);

Text.Title = Title;
Text.Subtitle = Subtitle;
Text.Data = TextData;

export default Text;
